/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCommitmentDetail {
    getFixupPrototypeFunction() { return BillingCommitmentDetail.fixupPrototype; }

    static newInstance(model: Partial<BillingCommitmentDetail>): BillingCommitmentDetail {
        let obj = Object.assign(new BillingCommitmentDetail(), model);
        BillingCommitmentDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCommitmentDetail>): BillingCommitmentDetail {
        if (!model) return null;
        return BillingCommitmentDetail.newInstance(<BillingCommitmentDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCommitmentDetail) {
        if (!obj) return;

        models.BillingCommitmentDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCommitmentDetail): boolean {
        Object.setPrototypeOf(obj, BillingCommitmentDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.billing_commitments) {
            for (let val of this.billing_commitments) {
                models.BillingCommitmentDefinition.fixupPrototype(val);
            }
        }
    }

    billing_commitments: Array<models.BillingCommitmentDefinition>;

}
